import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = ["name", "min", "max", "required", "placeholder", "aria-label"]
const _hoisted_3 = ["disabled"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.getClass('number-spinner-container') + ' '
  + (_ctx.isHorizontal ? _ctx.getClass('form-item--horizontal') : _ctx.getClass('form-item--vertical')))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.getClass('form-item__label')),
      style: _normalizeStyle(_ctx.computedFontStyle)
    }, _toDisplayString(_ctx.component.label), 7 /* TEXT, CLASS, STYLE */),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.getClass('form-item__input'))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.getClass('number-spinner') + ' '
      + (_ctx.isFieldValid ? '' : _ctx.getClass('form-item--invalid')))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.getClass('number-spinner__inner'))
        }, [
          _createElementVNode("button", {
            class: _normalizeClass(_ctx.getClass('number-spinner__button')),
            type: "button",
            "aria-label": "Decrease",
            disabled: _ctx.isDecreaseDisabled,
            onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.decreaseValue && _ctx.decreaseValue(...args)))
          }, _cache[4] || (_cache[4] = [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "aria-hidden": "true"
            }, [
              _createElementVNode("path", { d: "M5 12h14" })
            ], -1 /* HOISTED */)
          ]), 10 /* CLASS, PROPS */, _hoisted_1),
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(_ctx.getClass('number-spinner__input')),
            type: "number",
            ref: "input",
            "aria-roledescription": "Number field",
            autocomplete: "off",
            name: _ctx.component && _ctx.component.name ? _ctx.component.name : 'field_name',
            min: _ctx.component && _ctx.component.minValue ? _ctx.component.minValue : 0,
            max: _ctx.component && _ctx.component.maxValue ? _ctx.component.maxValue : 100,
            required: _ctx.component && _ctx.component.isRequired ? _ctx.component.isRequired : false,
            placeholder: _ctx.component && _ctx.component.placeholder ? _ctx.component.placeholder : '',
            "aria-label": _ctx.component && _ctx.component.label ? _ctx.component.label : 'Number field',
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.fieldValue) = $event)),
            onInput: _cache[2] || (_cache[2] = (...args) => (_ctx.onSpinnerInput && _ctx.onSpinnerInput(...args)))
          }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_2), [
            [
              _vModelText,
              _ctx.fieldValue,
              void 0,
              { trim: true }
            ]
          ]),
          _createElementVNode("button", {
            class: _normalizeClass(_ctx.getClass('number-spinner__button')),
            type: "button",
            "aria-label": "Increase",
            disabled: _ctx.isIncreaseDisabled,
            onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.increaseValue && _ctx.increaseValue(...args)))
          }, _cache[5] || (_cache[5] = [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "aria-hidden": "true"
            }, [
              _createElementVNode("path", { d: "M5 12h14" }),
              _createElementVNode("path", { d: "M12 5v14" })
            ], -1 /* HOISTED */)
          ]), 10 /* CLASS, PROPS */, _hoisted_3)
        ], 2 /* CLASS */)
      ], 2 /* CLASS */)
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}